// extracted by mini-css-extract-plugin
module.exports = {"body":"AutoLogoutPopup_body__23NZH","logoutButton":"AutoLogoutPopup_logoutButton__36ibt","em":"AutoLogoutPopup_em__2Cjnc"};